import { Theme, rem, base, reset } from '@thiememeulenhoff/lit-sdk';
import { css } from 'lit';
import { tagName } from '../../helpers';

export const tag = tagName('action-menu');
export const theme = new Theme(tag);

export const actionMenuStyles = [
  base.focus,
  reset.button,
  css`
    div.main {
      position: relative;
    }
    dialog {
      border: 0;
      border-radius: ${rem(6)};
      filter: drop-shadow(2px 2px 2px grey);
      inline-size: max-content;
      inset-block-start: 0;
      inset-inline-start: 0;
      overflow: hidden;
      padding: 0px;
      position: absolute;
      z-index: var(--z-index);
    }

    dialog:focus-visible {
      outline: none;
    }
  `,
];
